// extracted by mini-css-extract-plugin
module.exports = {"rowFlex":"SRY2kakoVGuP7C1v6F9s6w==","columnFlex":"_6WEt9qXghSwjWhATevv0Mg==","wrapper":"HjMFRbi47SoJdzaJVdJ5sg==","alignText":"dUShQ0PUw7GsWHZKNQB3uQ=="};